import text from '@/assets/logos/ortopediteknikk-logo-text-sharp.svg?raw'
import icon from '@/assets/logos/ortopediteknikk-logo-icon.svg?raw'
import styles from './Logo.module.css'

export type LogoVariant = 'text' | 'icon'

export type LogoProps = {
  variant?: LogoVariant | undefined
  title?: string | undefined
  /** Hide from assistive tech — for when another Logo next to this one
   * already announces the brand name. */
  decorative?: boolean | undefined
  className?: string | undefined
}

const SOURCE: Record<LogoVariant, string> = {
  text,
  icon,
}

export default function Logo({
  variant = 'text',
  title = 'Ortopediteknikk',
  decorative = false,
  className,
}: LogoProps) {
  return (
    <span
      {...(decorative
        ? { 'aria-hidden': true }
        : { role: 'img', 'aria-label': title })}
      className={`${styles.logo} ${styles[variant]} ${className ?? ''}`}
      dangerouslySetInnerHTML={{ __html: SOURCE[variant] }}
    />
  )
}
